// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Bi_k","content":"styles_content__2GbPr"};